import { createSlice } from "@reduxjs/toolkit";
import {
  changePassword,
  deleteAccount,
  disableAccount,
  fetchfreelancerProfile,
  fetchOffers,
  fetchSubscriptionData,
  planCancel,
  fetchSubscriptions,
  freelancerSignUp,
  profileStep1Submit,
  profileStep2Submit,
  profileStep3Submit,
  profileStep4Submit,
  purchaseSubscription,
  freelancerUpdateProfile,
  fetchPostJobs,
  freelancerUpdateProfileStep,
} from "../actions/authAction";
import { setProfile } from "../../../../utils/pip";

const initialState = {
  isLoading: false,
  subLoading: false,
  isFindAJobModal: false,
  registerStep: 1,
  freelancerProfileData: {},
  subscriptionList: [],
  offerList: [],
  freelancerSubscriptionPlan: [],
  freelancersJobs: []
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setRegisterStep: (state, action) => {
      state.registerStep = action.payload;
    },
    setIsFindAJobModal: (state, action) => {
      state.isFindAJobModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    // freelancer-sign-up
    builder.addCase(freelancerSignUp.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(freelancerSignUp.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(freelancerSignUp.rejected, (state, action) => {
      state.subLoading = false;
    });

    // fetch-subscription
    builder.addCase(fetchSubscriptions.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.subscriptionList = data ?? [];
      state.subLoading = false;
    });
    builder.addCase(fetchSubscriptions.rejected, (state, action) => {
      state.subLoading = false;
    });

    // purchase-subscription
    builder.addCase(purchaseSubscription.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(purchaseSubscription.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(purchaseSubscription.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step1-submit
    builder.addCase(profileStep1Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep1Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep1Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step2-submit
    builder.addCase(profileStep2Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep2Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep2Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step3-submit
    builder.addCase(profileStep3Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep3Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep3Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step4-submit
    builder.addCase(profileStep4Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep4Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep4Submit.rejected, (state, action) => {
      state.subLoading = false;
    });

    // fetch-freelancer-profile
    builder.addCase(fetchfreelancerProfile.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchfreelancerProfile.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.freelancerProfileData = data || {};
      state.subLoading = false;
    });
    builder.addCase(fetchfreelancerProfile.rejected, (state, action) => {
      state.subLoading = false;
    });
    // fetch-offers
    builder.addCase(fetchOffers.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.offerList = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.subLoading = false;
    });

    // change-password
    builder.addCase(changePassword.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.subLoading = false;
    });

    // account-disable
    builder.addCase(disableAccount.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(disableAccount.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(disableAccount.rejected, (state, action) => {
      state.subLoading = false;
    });

    // account-delete
    builder.addCase(deleteAccount.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteAccount.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchSubscriptionData
    builder.addCase(fetchSubscriptionData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSubscriptionData.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.freelancerSubscriptionPlan = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchSubscriptionData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // planCancel
    builder.addCase(planCancel.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(planCancel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(planCancel.rejected, (state, action) => {
      state.isLoading = false;
    });

    // freelancer-profile-update
    builder.addCase(freelancerUpdateProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(freelancerUpdateProfile.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(freelancerUpdateProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchPostJobs
    builder.addCase(fetchPostJobs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPostJobs.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.freelancersJobs = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchPostJobs.rejected, (state, action) => {
      state.isLoading = false;
    });

    // freelancerUpdateProfileStep
    builder.addCase(freelancerUpdateProfileStep.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(freelancerUpdateProfileStep.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(freelancerUpdateProfileStep.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default authSlice.reducer;
export const { setRegisterStep, setIsFindAJobModal } = authSlice.actions;
